<ng-container >
    <app-data-table [columns]="cols"
     [data]="unit"
     [url]="'/master/units/'"
      [isCardView]="false" 
      (onPresentView)="getSystem()"
       [title]="title"
        [isDeletable]="'/master/unit' | hasPermission: 'Delete'"  [showAddButton]="'/master/unit' | hasPermission: 'Add'" [showActions]="canEditSetup" [isEditable]="'/master/unit' | hasPermission: 'Edit'" 
        (viewEventRow)="viewSystem($event)" [isView]="'/master/unit' | hasPermission: 'View'"
       (onAdd)="addSystem()"
       (editEventRow)="updateUnit($event)"
       (deleteEventRow)="showDeletePopup($event)" 
       (onLazyLoadData)="getSystem($event)" [totalRecords]="totalRecords"
       >
    </app-data-table>
</ng-container>

<ng-template pTemplate="emptymessage">
    <tr>
        <td colspan="5">
                <h5 class="btn btn-warning mx-auto d-block">
                    No records found! Please add/upload data to populate the table.
                </h5>
        </td>
    </tr>
</ng-template>


<!-- Add Unit Dialog -->
<app-reusable-dialog
  [(visible)]="showDialog"
  [config]="addDialogConfig"
  [initialData]="{}"
  [viewMode]="false"
  (onSubmit)="onSubmitAdd($event)"
  (onCancel)="onCancelDialog()"
  (onClose)="onCloseDialog()">
</app-reusable-dialog>



<!-- Edit/View Unit Dialog -->
<app-reusable-dialog
  [(visible)]="isUpdatedialog"
  [config]="editDialogConfig"
  [initialData]="selectedUnitData"
  [viewMode]="viewMode"
  (onSubmit)="onSubmitEdit($event)"
  (onCancel)="onCancelDialog()"
  (onClose)="onCloseDialog()">
</app-reusable-dialog>

<p-dialog header="Delete Unit" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }" [maximizable]="true">
  <div class="delete-dialog mt-3">
     <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <span>Are you sure , you want to delete unit ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteSystem()" class="mt-2">
    </p-button>
  </div>
</p-dialog>